module.exports = __webpack_public_path__ + "static/media/loyalty_rewards-dt-en.70bc7cfa.jpg";